import type { DeliveryType } from '@/types/scheduling';
import type { StudentSchedulingDetails } from '../api/getStudentsSchedulingDetails';

export const getSelectedDeliveryCenterSchedulingDetails = (
  studentsSchedulingDetails: StudentSchedulingDetails[],
  studentId: number,
  selectedDeliveryType: DeliveryType,
) => {
  if (selectedDeliveryType === 'online') {
    return studentsSchedulingDetails.find((student) => student.id === studentId)?.onlineCenterSettings;
  }

  return studentsSchedulingDetails.find((student) => student.id === studentId)?.inCenterCenterSettings;
};
